module.exports = __webpack_public_path__ + "img/woman_gift.38a02e7c.png";